module.exports = __webpack_public_path__ + "static/img/img20.c923c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img20.png
// module id = VIgw
// module chunks = 1